import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ChangePasswordForm from './components/ChangePasswordForm';

function ChangePassword() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const tabItems = [{ id: 1, value: 'Ubah Kata Sandi' }];

  return (
    <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="text-30 lh-14 fw-600">Pengaturan</h1>
        </div>
        <div className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20">
          <div className="tabs -underline-2 js-tabs">
            <div className="tabs__controls row x-gap-40 y-gap-10 lg:x-gap-20 js-tabs-controls">
              {tabItems.map((item, index) => (
                <div className="col-auto" key={item.id}>
                  <button
                    type="button"
                    className={`tabs__button text-16 lg:text-16 text-light-1 fw-500 pb-5 lg:pb-0 js-tabs-button ${
                      activeTab === index ? 'is-tab-el-active' : ''
                    }`}
                    onClick={() => handleTabClick(index)}>
                    {item.value}
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="tabs__content pt-30 js-tabs-content">
            <div className="tabs__pane -tab-item-1 is-tab-el-active">
              <ChangePasswordForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
